module.exports = __webpack_public_path__ + "img/header-background-en.0ef6256d.png";